import { useState, useEffect } from "react";

export const useCalendarEvents = (currencyPair, page = 1, limit = 10) => {
  // State to store calendar event data
  const [calendarEventData, setCalendarEventData] = useState([]);
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state

  useEffect(() => {
    // Validate currency pair
    if (!currencyPair) {
      setError("Currency pair is required");
      setLoading(false);
      return;
    }

    // Function to fetch calendar events from the backend
    const fetchCalendarEvents = async () => {
      setLoading(true); // Start loading
      setError(null); // Reset any previous error

      try {
        // Make POST request to fetch data
        const response = await fetch("https://vidplay-api.deng-software.com/fx/calendarEvents", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ currencyPair, page, limit }), // Include pagination info
        });

        // Check if the response is OK
        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        // Ensure the expected data structure
        if (!data || !Array.isArray(data.events) || typeof data.pagination.totalPages !== "number") {
          throw new Error("Invalid data format received from the server");
        }

        setCalendarEventData(data.events); // Update state with the fetched data
        setTotalPages(data.pagination.totalPages); // Update the total pages
      } catch (err) {
        console.error("Error fetching calendar events:", err);
        setError(`Failed to fetch calendar events: ${err.message}`);
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchCalendarEvents(); // Invoke fetch function
  }, [currencyPair, page, limit]); // Dependency: re-fetch when currencyPair, page, or limit changes

  // Return data and state
  return { calendarEventData, totalPages, loading, error };
};
